/*
 * @Author: Teemo Ding
 * @Date: 2021-09-17 09:15:59
 * @LastEditTime: 2021-09-17 17:43:49
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Alert/index.tsx
 */
import React, { ReactNode } from 'react';
import { Alert as AlertAntd } from 'antd';
import css from './css.module.less';

interface IProps {
  action?: string | ReactNode;
  description?: string | ReactNode;
  message: string | ReactNode;
  [k: string]: any;
}

const Alert = ({ action, description, message, ...rest }: IProps) => {
  return (
    <AlertAntd
      {...(description ? { description: ' ' } : {})}
      message={
        <div className={css.alert}>
          <div>
            <div className={css.message}>{message}</div>
            <div>{description}</div>
          </div>
          {action}
        </div>
      }
      {...rest}
    />
  );
};

export default Alert;
